/* esm.sh - buffer@6.0.3 */
export * from "/*buffer@6.0.3/esnext/buffer.mjs";
export { default } from "/*buffer@6.0.3/esnext/buffer.mjs";
